import { useMemo } from "react";
import type { Clarification } from "../types/clarification.type";

interface ClarificationWithUnread extends Clarification {
  conversation_unread_count?: number;
}

export const useClarificationUnreadCounts = (
  clarifications: ClarificationWithUnread[]
): Map<number, number> => {
  return useMemo(() => {
    const counts = new Map<number, number>();

    clarifications.forEach((c) => {
      if (c.is_sent && c.conversation_unread_count && c.conversation_unread_count > 0) {
        counts.set(c.id, c.conversation_unread_count);
      }
    });

    return counts;
  }, [clarifications]);
};
